import { apiProvider } from './api';
import { NAME, PP_FILTER_ENUM, PP_PREFIX_STRINGS, PP_TYPES, PP_WILDCARD_STRINGS } from './constants';
import { router } from './router';

export const PracovniPozice = {
	name: NAME,
	apiProvider,
	router,
	ppTypes: PP_TYPES,
	ppWildcards: PP_WILDCARD_STRINGS,
	ppPrefix: PP_PREFIX_STRINGS,
	ppFilterEnum: PP_FILTER_ENUM,
};
